import { Typography, Box } from '@mui/material';
import { PrismicRichText } from '@prismicio/react';

import { useStyles } from './useStyles';

interface IRichTextComponent {
  slice: any;
}

const RichTextComponent = ({ slice }: IRichTextComponent) => {
  const { title, special_instruction, description } = slice?.primary || {};

  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        <Box className={classes.itemContainer}>
          {title ? (
            <Typography
              variant="h3"
              align="left"
              color="cinnamon.main"
              mb="25px"
            >
              {title}
            </Typography>
          ) : null}
          <PrismicRichText
            field={description}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="body2"
                  align="justify"
                  color="garamMasala.main"
                  sx={{ overflowWrap: 'anywhere' }}
                >
                  {children}
                </Typography>
              ),
              oList: ({ children }) => {
                return <ol className={classes.orderedlist}>{children}</ol>;
              },
              oListItem: ({ children }) => {
                return (
                  <li className={classes.listItem}>
                    <Typography
                      component={'span'}
                      variant="body2"
                      align="justify"
                      color="garamMasala.main"
                    >
                      {children}
                    </Typography>
                  </li>
                );
              },

              list: ({ children }) => {
                return <ul className={classes.unorderedlist}>{children}</ul>;
              },

              listItem: ({ children }) => {
                return (
                  <li className={classes.unorderedlistItem}>
                    <Typography
                      variant="body2"
                      align="justify"
                      color="garamMasala.main"
                    >
                      {children}
                    </Typography>
                  </li>
                );
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default RichTextComponent;
